import { Injectable } from "@angular/core";
import { LinkDeviceEndTransmissionService } from "./link-device-end-transmission.service";
import { EndInputs, SelectedEnd } from "../link-device-model";
import { MuxDemux, Transmission } from "../../../../links.model";

/**
 * Serviço responsável por tratar a inicialização de Mux/Demux para Ends de Links.
 */
@Injectable({
    providedIn: "root"
})
export class LinkDeviceMuxDemuxService {

    constructor(private readonly linkDeviceEndTransmissionService: LinkDeviceEndTransmissionService) {
        // Construtor intencionalmente vazio
    }

    initMuxes(muxes: MuxDemux[], endInputs: EndInputs, selectedEnd: SelectedEnd, muxResourceId: number) {
        endInputs.endMuxes = [];
        selectedEnd.endMuxSelected = null;

        if (muxes.length > 0) {
            endInputs.endMuxes.push(...muxes);
        }

        selectedEnd.endMuxSelected = muxes.find(mux => mux.resourceId === muxResourceId) || muxes[0];

        if (selectedEnd.endMuxSelected?.txTransmission) {
            this.linkDeviceEndTransmissionService
                .updateTransmissionLinked(endInputs, selectedEnd.endMuxSelected, Transmission.TX);
        }

        if (selectedEnd.endMuxSelected?.rxTransmission) {
            this.linkDeviceEndTransmissionService
                .updateTransmissionLinked(endInputs, selectedEnd.endMuxSelected, Transmission.RX);
        }
    }

}
